var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMentionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9C12.75 11.0711 11.0711 12.75 9 12.75C6.92893 12.75 5.25 11.0711 5.25 9C5.25 6.92893 6.92893 5.25 9 5.25C11.0711 5.25 12.75 6.92893 12.75 9ZM12.75 9C12.75 10.3807 13.5895 11.5 14.625 11.5C15.6605 11.5 16.5 10.3807 16.5 9.00001C16.5 7.08059 15.7678 5.16117 14.3033 3.6967C11.3744 0.767767 6.62563 0.767767 3.6967 3.6967C0.767767 6.62563 0.767767 11.3744 3.6967 14.3033C6.62563 17.2322 11.3744 17.2322 14.3033 14.3033M12.75 9V5.875",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionIcon);
export default __webpack_public_path__ + "static/media/mention-icon.88ff1937fd8ede7abdce67cb33c19e14.svg";
export { ForwardRef as ReactComponent };